import React, {useEffect, useState} from 'react';
import axios from '../Common/axios';
import InfoTable from './InfoTable';
import { Modal } from 'antd';
import {measureColumnData} from './columns';
import {getFindInfoMeasureListData, postSaveVaMeasureData} from '../Common/api';

import {measureListData} from '../Common/tempData';

function InfoMeasure({reportId}) {

    const [dataSource, setDataSource] = useState(measureListData);
    //const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const titleName="진단항목 등록";

    useEffect(() => {
        //자동조회
        if(reportId) {
            findInfoChecklistListData();
        }
    }, []);

    const findInfoChecklistListData = () => {
        // 보고서ID 필수조건 체크
        if (reportId == '') {
            Modal.info({title:titleName, content:"Report ID가 누락되었습니다."});
            return;
        }

        setIsLoading(true);
        axios.get(getFindInfoMeasureListData(reportId))
            .then((response) => {
                //console.log(response);
                setIsLoading(false);
                setDataSource(response.data);
                //if(response.data.totalCount == 0) {
                //    Modal.info({title: "No Data.", okText:"Close"});
                //} 
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    // 저장 클릭 시
    const onClickSaveHandler = (saveData) => {

        // 변경건이 있으면 추가
        if(saveData.length > 0) {
            saveCheckList(saveData);
        } else {
            Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        }

    }

    // 등록/수정/삭제 API
    const saveCheckList = (saveData) => {

        axios.post(postSaveVaMeasureData()
                        , {reportId : reportId, saveData : saveData}
                        , {logType:'/edit/TemplateMeasure/', logParam : reportId})
        .then((response) => {
            //console.log(response);
            //Modal.info({title: "OK.", okText:"Close"});
            if(response.data == '000') {
                Modal.info({title:titleName, content:"데이터가 등록 되었습니다.", okText:"Close"});
            } else {
                Modal.info({title:titleName, content:response.data, okText:"Close"});  
            }

            //재조회
            findInfoChecklistListData();
        })
        .catch((error) => {
            Modal.error({title:titleName, content:error.message, okText:"Close"});
        });
    };

    // 정보 변경시 재조회
    const onReloadHandler = () => {
        //재조회
        findInfoChecklistListData();
    }
    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <div className='tab_content'>
                <InfoTable
                    data={dataSource} 
                    rowkey="id"
                    columnData={measureColumnData}
                    reportId={reportId}
                    infoType={'measure'}
                    isLoading={isLoading} 
                    onClickSaveHandler={onClickSaveHandler}
                    onReloadHandler={onReloadHandler}
                    fullHeight={!!window.opener}/>
            </div>
        </>
    );
}

export default InfoMeasure;